module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"today":"Today at"}}')
  delete Component.options._Ctor
}
